var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategoryd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3960",
    "data-name": "Rectangle 3960",
    width: 24,
    height: 24,
    transform: "translate(60 179)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4744",
    "data-name": "Mask Group 4744",
    transform: "translate(-60 -179)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7631",
    "data-name": "Group 7631",
    transform: "translate(64 183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7630",
    "data-name": "Group 7630"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8232",
    "data-name": "Path 8232",
    d: "M0,3.743Q0,2.3,0,.863A.77.77,0,0,1,.854,0h5.8A.767.767,0,0,1,7.5.847q0,2.906,0,5.813a.765.765,0,0,1-.836.844q-2.916,0-5.831,0A.766.766,0,0,1,0,6.658Q0,5.2,0,3.743M1.51,5.989H5.987V1.513H1.51Z",
    transform: "translate(0 -0.001)",
    fill: "#ffc400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8233",
    "data-name": "Path 8233",
    d: "M195.428,7.5h-2.881a.771.771,0,0,1-.861-.854q0-2.9,0-5.8A.767.767,0,0,1,192.532,0h5.814a.764.764,0,0,1,.843.836q0,2.915,0,5.831a.765.765,0,0,1-.845.835q-1.458,0-2.916,0m2.251-5.988H193.2V5.991h4.477Z",
    transform: "translate(-182.689 0)",
    fill: "#ffc400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8234",
    "data-name": "Path 8234",
    d: "M0,195.4q0-1.431,0-2.863a.776.776,0,0,1,.87-.88H6.636a.775.775,0,0,1,.871.879q0,2.871,0,5.743a.779.779,0,0,1-.888.88H.893a.782.782,0,0,1-.889-.9q0-1.431,0-2.863m5.988-2.226H1.516v4.476H5.992Z",
    transform: "translate(-0.004 -182.664)",
    fill: "#ffc400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8235",
    "data-name": "Path 8235",
    d: "M191.735,195.528a3.748,3.748,0,1,1,3.86,3.643,3.757,3.757,0,0,1-3.86-3.643m3.756-2.351a2.248,2.248,0,1,0,2.242,2.233,2.251,2.251,0,0,0-2.242-2.233",
    transform: "translate(-182.735 -182.679)",
    fill: "#ffc400"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryd);
export default __webpack_public_path__ + "static/media/categoryd.0d77eb13cf6649a70dd5e8655a5f999a.svg";
export { ForwardRef as ReactComponent };